const en: Record<string, string> = {
  // ── Navigation sections ──────────────────────────────────────────────────
  'nav.section.agentic':      'Agentic',
  'nav.section.knowledge':    'Knowledge',
  'nav.section.tools':        'Tools',
  'nav.section.settings':     'Settings',
  'nav.section.organization': 'Organization',

  // ── Navigation items ─────────────────────────────────────────────────────
  'nav.agents':       'Agents',
  'nav.connectors':   'Connectors',
  'nav.marketplace':  'Marketplace',
  'nav.brain':        'Brain',
  'nav.playground':   'Playground',
  'nav.roadmap':      'Roadmap',
  'nav.docs':         'Documentation',
  'nav.apiDocs':      'API Reference',
  'nav.changelog':    'Changelog',
  'nav.organization': 'Organization',
  'nav.tokens':       'LLM Tokens',
  'nav.mcps':         'MCPs',

  // ── User menu ────────────────────────────────────────────────────────────
  'user.menu.settings':     'Settings',
  'user.menu.organization': 'Manage Organization',
  'user.menu.logout':       'Sign out',
  'user.newAgent':          'New agent',

  // ── Common actions ───────────────────────────────────────────────────────
  'common.save':      'Save',
  'common.cancel':    'Cancel',
  'common.delete':    'Delete',
  'common.create':    'Create',
  'common.edit':      'Edit',
  'common.preview':   'Preview',
  'common.reload':    'Reload',
  'common.loading':   'Loading...',
  'common.error':     'Error',
  'common.success':   'Success',
  'common.confirm':   'Confirm',
  'common.search':    'Search',
  'common.filter':    'Filter',
  'common.export':    'Export',
  'common.import':    'Import',
  'common.close':     'Close',
  'common.back':      'Back',
  'common.next':      'Next',
  'common.previous':  'Previous',
  'common.yes':       'Yes',
  'common.no':        'No',
  'common.unknown':   'Unknown',

  // ── Brain ────────────────────────────────────────────────────────────────
  'brain.title':           'Cubicup Brain',
  'brain.newDept':         'New department',
  'brain.newDoc':          'New document',
  'brain.reload':          'Reload',
  'brain.emptyRepo':       'Empty repo. Create the first department.',
  'brain.selectDoc':       'Select a document to get started',
  'brain.selectDocHint':   'or create a department from the sidebar',
  'brain.unsaved':         'Unsaved',
  'brain.saved':           'Saved',
  'brain.deleteTitle':     'Delete this document?',
  'brain.deleteWarning':   'This action cannot be undone.',
  'brain.readmeNote':      'A README.md will be automatically created in the folder.',
  'brain.selectDeptFirst': 'Select a department first',
  'brain.deptPlaceholder': 'e.g. Human Resources',
  'brain.docPlaceholder':  'e.g. onboarding-process',
  'brain.deptCreated':     'Department created',
  'brain.docCreated':      'Document created',
  'brain.docDeleted':      'File deleted',
  'brain.loadError':       'Could not load Brain. Please try again in a few minutes.',
  'brain.fileError':       'Could not load file',
  'brain.saveError':       'Error saving file',
  'brain.deleteError':     'Error deleting file',
  'brain.deptError':       'Error creating department',
  'brain.docError':        'Error creating document',

  // ── Agents ───────────────────────────────────────────────────────────────
  'agents.title':          'Agents',
  'agents.newAgent':       'New agent',
  'agents.empty':          'No agents yet',
  'agents.emptyHint':      'Create your first agent to get started',
  'agents.delete':         'Delete agent',
  'agents.deleteConfirm':  'Delete this agent?',
  'agents.deleteWarning':  'All nodes and flows will also be deleted.',
  'agents.activate':       'Activate',
  'agents.activated':      'Agent activated',
  'agents.edit':           'Edit agent',
  'agents.created':        'Agent created',
  'agents.updated':        'Agent updated',
  'agents.deleted':        'Agent deleted',

  // ── Builder ──────────────────────────────────────────────────────────────
  'builder.flow':          'Flow',
  'builder.executions':    'Executions',
  'builder.ontologies':    'Ontologies',
  'builder.api':           'API',
  'builder.addNode':       'Add node',
  'builder.saveFlow':      'Save flow',
  'builder.flowSaved':     'Flow saved',
  'builder.activate':      'Activate agent',

  // ── Marketplace ──────────────────────────────────────────────────────────
  'marketplace.title':     'Marketplace',
  'marketplace.subtitle':  'Pre-built agents ready to use',
  'marketplace.install':   'Install',
  'marketplace.installed': 'Installed',

  // ── Connectors ───────────────────────────────────────────────────────────
  'connectors.title':      'Connectors',
  'connectors.subtitle':   'Connect CubicOS to your tools',
  'connectors.http':       'HTTP',
  'connectors.monday':     'Monday.com',
  'connectors.gdrive':     'Google Drive',
  'connectors.test':       'Test connection',
  'connectors.save':       'Save connector',

  // ── Playground ───────────────────────────────────────────────────────────
  'playground.title':      'Playground',
  'playground.subtitle':   'Test your agents in real time',
  'playground.send':       'Send',
  'playground.clear':      'Clear',
  'playground.inputHint':  'Type a message...',

  // ── Organization ─────────────────────────────────────────────────────────
  'org.title':             'Organization',
  'org.users':             'Users & Teams',
  'org.ui':                'Manage UI',
  'org.teams':             'Teams',
  'org.members':           'Members',
  'org.addUser':           'Add user',
  'org.addTeam':           'Create team',
  'org.role.admin':        'Administrator',
  'org.role.editor':       'Editor',
  'org.role.viewer':       'Viewer',

  // ── Roles ────────────────────────────────────────────────────────────────
  'role.admin':   'Admin',
  'role.editor':  'Editor',
  'role.viewer':  'Viewer',

  // ── Login ────────────────────────────────────────────────────────────────
  'login.title':    'Welcome',
  'login.subtitle': 'Sign in with your Google account',
  'login.button':   'Continue with Google',

  // ── Errors ───────────────────────────────────────────────────────────────
  'error.generic':    'An unexpected error occurred',
  'error.notFound':   'Page not found',
  'error.forbidden':  'You do not have permission to view this page',
  'error.network':    'Network error. Check your connection.',

  // ── Footer ───────────────────────────────────────────────────────────────
  'footer.by':        'by',
};

export default en;
